import { fetchSQLQuery } from './sql-api';

/**
 * Browser QueryAPI adapter using existing sql-api.js WebSocket implementation.
 */
export const browserQueryAPI = {
  async fetchQuery(payload, path, options) {
    // Payload is already in SQL API format (built by buildPayload())
    // fetchSQLQuery handles the WebSocket communication
    return fetchSQLQuery(payload, path, {
      returnErrors: options?.returnErrors ?? true,
      return404AsError: options?.return404AsError,
      metricKey: options?.metricKey,
    });
  }
};
